import { ThirdPartyAppState } from "./thirdPartyApp.types";

export const state: ThirdPartyAppState = {
  loading: false,
  scopes: []
};
